import { render } from "./ClockDisplay.vue?vue&type=template&id=b8952054&scoped=true"
import script from "./ClockDisplay.vue?vue&type=script&lang=js"
export * from "./ClockDisplay.vue?vue&type=script&lang=js"

import "./ClockDisplay.vue?vue&type=style&index=0&id=b8952054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8952054"]])

export default __exports__